import { Toggle, cx } from '@raro/ui';
import type { Brand } from '../../lib/brands';

/**
 * O recorte da pessoa do cliente: a conta inteira (marcação explícita) ou as marcas dela. Sem nenhum dos dois, ela só vê
 * o que ela mesma pediu. Vale hoje para o Ritmo (demandas e calendário). Com uma marca só, sobra a marcação.
 */
export function MemberScope({ seesAll, brandIds, brands, disabled, onChange }: { seesAll: boolean; brandIds: string[]; brands: Brand[]; disabled?: boolean; onChange: (next: { seesAll: boolean; brandIds: string[] }) => void }) {
  const multi = brands.length > 1;
  const flip = (id: string) => onChange({ seesAll, brandIds: brandIds.includes(id) ? brandIds.filter((b) => b !== id) : [...brandIds, id] });
  return (
    <div className="rr-row rr-row--wrap" style={{ gap: 'var(--rr-space-3)', alignItems: 'center' }}>
      <Toggle checked={seesAll} disabled={disabled} onChange={(v) => onChange({ seesAll: v, brandIds })} label="vê a conta inteira" />
      {multi && !seesAll && brands.map((b) => (
        <button key={b.id} type="button" disabled={disabled} className={cx('rr-chip', brandIds.includes(b.id) && 'rr-chip--on')} style={{ cursor: 'pointer', background: brandIds.includes(b.id) ? undefined : 'none' }} onClick={() => flip(b.id)}>{b.name}</button>
      ))}
      {!seesAll && (multi ? brandIds.length === 0 : true) && <span className="rr-faint" style={{ fontSize: 'var(--rr-text-xs)' }}>{multi ? 'sem marca: só vê o que ela mesma pedir' : 'só vê o que ela mesma pedir'}</span>}
    </div>
  );
}
